export default __webpack_public_path__ + "static/media/logo_color_bg.c6d2fedf.svg";